// Parses the server-provided session start time (ISO8601). Returns null if
// missing/unparseable so callers can fall back to mount time.
//
// parseStartedAt's `null` return is treated differently by its two callers on
// purpose: useElapsedSeconds (VideoPanel.jsx, stays in place -- see its own
// comment) falls back to Date.now() at mount time, while call_button_controller.js
// has no mount-time fallback to fall back to, since it has no
// React lifecycle -- it must treat null as "no active call to time".
export function parseStartedAt(startedAt) {
  if (!startedAt) return null;
  const ms = Date.parse(startedAt);
  return Number.isNaN(ms) ? null : ms;
}

export function formatElapsed(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds)}`
    : `${minutes}:${pad(seconds)}`;
}
